import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header-data',
    templateUrl: './header-data.component.html',
    styleUrls: ['./header-data.component.scss'],
    standalone: false
})
export class HeaderDataComponent implements OnInit {
  @Input('items') public items: any[];
  currentItem: number;
  currentTitle: string;
  currentIcon: string;
  showParameter: boolean = false;
  showData: boolean = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events.subscribe(_ => this.getCurrentItem());
  }

  public handleTrigger(trigger, title): void {
    trigger();
    this.currentTitle = title
  }
  
  getCurrentItem() {
    let currentPath = this.router.url;
    const current = this.items.find((x) => x.route == currentPath);
    this.currentItem = current?.id;
    this.currentTitle = current?.title
    this.currentIcon = current?.icon
  }
}
